import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'bw-block-legacy',
    templateUrl: './block.component.html',
    styleUrls: ['./block.component.scss'],
    standalone: false
})
export class BlockComponentLegacy {

  @Input() secondaryStyle = false;
  @Input() showPointer = true;
  @Output() blockAction = new EventEmitter();

  handleBlockAction(event: Event) {
    this.blockAction.emit(event);
  }
}
